export default __webpack_public_path__ + "static/media/back.10332f84.svg";